module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAWwAAAAGCAYAAADnh6QxAAABOklEQVRoge3YMW7CQBCF4X/WS4OE5I4b0HIADsNRaN1wDCQan4OOmooTUBoJ4fVMqt04kaLYRZpovsb2ar2Wm6fREzMznHPOTZZSoqoqRKSsmdmX55/kfWZW7kWE5/PJfr/nfD4TY2QYBqqqAkBVCSEQ/uyPnHPuH1JVYowlnN/vd1mfQkRIKSEihBDKOcfjkbZtOZ1OJazNrIR13/cI4BO2c85NFEIo4Zwn7bnyZN33PYvFgvv9zna7pes61us1t9uNuq75XoBEb0Scc266XGWE8FlQ5Ck4X38zDmuAw+FA13UAPB4PmqahaRpSSmWPqiLeYTvn3HTjrnrcM8+Rg93MuFwu7Ha7cqaZsVwuuV6vbDYbVLV8wwPbOedmypXIeKqeE97jd4Zh4PV6lTNVFRFhtVoRYwQoXfYHncu4uJ0Gn9AAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/view/images/y75.png
// module id = m3Vv
// module chunks = 1